/**
 * @file index.tsx
 *
 * @fileoverview Displays the form that handles searching for fulltext and region autocomplete.
 */
import React from 'react';
import SearchInputForm from '~/jobiqo/components/Search/SearchInputForm';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface JobsSearchInputFormProps {
  /**
   * The current querystring object.
   */
  querystring?: any;
  /**
   * Override the search URL. Defaults to the configured jobs page.
   */
  searchUrl?: string;
  /**
   * Hide the geo search field.
   */
  hideGeoSearch?: boolean;
  /**
   * The radius search flag.
   */
  radiusSearch?: boolean;
}

export const JobsSearchInputForm = ({
  querystring,
  searchUrl,
  hideGeoSearch,
  radiusSearch,
}: JobsSearchInputFormProps) => {
  const { JOBS } = useFrontendConfig();
  return (
    <SearchInputForm
      querystring={querystring}
      endpoint="jobs"
      searchUrl={searchUrl ?? JOBS.JOBS_PAGE}
      geoInfo={JOBS.GEO_INFO}
      hideGeoSearch={hideGeoSearch ?? JOBS.HIDE_GEO_SEARCH}
      hideKeywordSearch={JOBS.HIDE_KEYWORD_SEARCH}
      radiusSearch={radiusSearch}
    />
  );
};
